import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dot from './TopicHeaderDot/TopicHeaderDot';
import styles from '../TopicDots.module.css';
import { development, production } from '../../../config';

let audioPath = production;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') audioPath = development;

class TopicHeaderDots extends Component {
	state = {
		selectedTopicId: parseInt(this.props.selectedTopicId),
		playAudioRef: null
	}

	generateDots = () => {
		const topic = this.state.selectedTopicId, dots = [];
		// Topics 5, 6, 7, 9 and 10 have only 4 question dots
		const totalDots = (topic === 5 || topic === 6 || topic === 7 || topic === 9 || topic === 10) ? 4 : 5;
		for (let i = 1; i <= totalDots; i++) {
			const key = `dot-${topic}-${i}`;
			const fileName = `T${topic}-q${i}.mp3`;
			dots.push(
				<Dot key={key}
				     audioSrc={`${audioPath}/app-2/${fileName}`}
				     audioRefToPlay={audioRef => this.setState({ playAudioRef: audioRef }) }
				     playAudio={this.state.playAudioRef}
				     disableMenuButton={val => this.props.disableMenuButton(val)}
				/>
			)
		}
		return dots;
	}

	componentDidUpdate(prevProps) {
		if (prevProps.selectedTopicId !== this.props.selectedTopicId) {
			this.setState({ selectedTopicId: parseInt(this.props.selectedTopicId) })
		}
	}

	render() {
		return (
			<div className={styles.DotsContainer}>
				{this.generateDots()}
			</div>
		)
	}
}

const mapStateToProps = state => ({ selectedTopicId: state.topicListReducer.selectedTopicId });

export default connect(mapStateToProps)(TopicHeaderDots);